import React, { useState, useContext, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { CARDS_PAGE_PATH } from "../../App";
import { CATEGORIES, PERMISSION_LEVEL_ENUM } from "../../App.helpers";
import ExternalLink from "../../icons/external-link.svg";
import Lock from "../../icons/lock.svg";
import LogoDatassential from "../../images/logo-datassential.svg";
import LogoKinetic from "../../images/logo-kinetic.svg";
import './HeaderMenu.styles.scss';
import { AppContext } from '../../App';

function HeaderMenu() {
    const [redirectAfterLoginLink, setRedirectAfterLoginLink] = useState('');
    const { isAuthorized, setIsLoginModalActive, credentials } = useContext(AppContext);
    const MENU_ITEMS = [
        {
            type: 'url',
            path: process.env.REACT_APP_LANDSCAPE,
            title: 'Operator Landscape',
            className: 'header-menu__item--first',
        },
        {
            type: isAuthorized ? 'url' : 'redirect',
            path: process.env.REACT_APP_MARKET,
            title: 'GO TO MARKET',
            className: 'header-menu__item--second',
            locked: credentials.permissionLevel > PERMISSION_LEVEL_ENUM.NOT_SET && credentials.permissionLevel <= PERMISSION_LEVEL_ENUM.GUEST,
        },
        {
            type: 'link',
            path: '/',
            title: (<>Consumer Food Journey <sup>SM</sup></>),
            className: 'header-menu__item--third',
        },
        ...CATEGORIES.map(category => ({
            type: 'link',
            path: `${CARDS_PAGE_PATH}/${category.path}`,
            title: category.title,
            className: 'header-menu__item--rest',
            locked: credentials.permissionLevel > PERMISSION_LEVEL_ENUM.NOT_SET && category.permissionLevel > credentials.permissionLevel,
        })),
    ];

    const handleClickRedirect = (link) => {
        setIsLoginModalActive(true);
        setRedirectAfterLoginLink(link);
    };

    useEffect(() => {
        if (isAuthorized && redirectAfterLoginLink) {
            window.location.href = redirectAfterLoginLink;
        }
    }, [isAuthorized]);

    return (
        <div className="header-menu jalousie__list">
            {MENU_ITEMS.map(({ locked, ...menuItem }) => {
                const className = [
                    'header-menu__item',
                    menuItem.className,
                    locked && 'header-menu__item--locked'
                ];
                return (
                    <div key={menuItem.title} className="jalousie__item">
                        {menuItem.type === 'redirect' && (
                            <button
                                onClick={() => handleClickRedirect(menuItem.path)}
                                className={className.join(' ')}
                            >
                                {menuItem.title}
                                {locked && (<Lock className="header-menu__lock" />)}
                            </button>
                        )}
                        {menuItem.type === 'url' && (
                            <a
                                href={menuItem.path}
                                className={className.join(' ')}
                            >
                                {menuItem.title}
                                {locked && (<Lock className="header-menu__lock" />)}
                            </a>
                        )}
                        {menuItem.type === 'link' && (
                            <NavLink
                                to={menuItem.path}
                                className={className.join(' ')}
                            >
                                {menuItem.title}
                                {locked && (<Lock className="header-menu__lock" />)}
                            </NavLink>
                        )}
                    </div>
                );
            })}
            <div className="jalousie__item">
                <div className="header-menu__item header-menu__item--last">
                    <div className="header-menu__link">
                        <a
                            rel="noopener noreferrer"
                            target="_blank"
                            href="https://ifmaworld.com"
                        >
                            <ExternalLink/>
                            go to IFMAworld.com
                        </a>
                    </div>
                    <div className="header-menu__links">
                        <a target="_blank" href='https://datassential.com' className="page-footer__img">
                            <LogoDatassential
                                width={115}
                                height={10}
                            />
                        </a>
                        <a target="_blank" href='https://kinetic12.com' className="page-footer__img">
                            <LogoKinetic
                                width={40}
                                height={20}
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeaderMenu;